import { render, staticRenderFns } from "./ProjectAll.vue?vue&type=template&id=39df0e1b&"
import script from "./ProjectAll.vue?vue&type=script&lang=ts&"
export * from "./ProjectAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports